<div class="qr flex flex-col items-center">
  <div class="float__icon increase" inlineSVG="features/increase.svg"></div>
  <div class="float__icon decrease" inlineSVG="features/decrease.svg"></div>
  <div class="qr__container">
    <p translate="QR Code Generator"></p>
    <span inlineSVG="features/qrcode.svg" style="    width: 257px;
    height: 257px;"></span>
  </div>
  <app-statistics-card class="visitors__card" cardTitle="Total Visitors" total="12,489"
    icon="features/profile.svg"></app-statistics-card>
  <app-statistics-card class="scans__card" cardTitle="Total Scans" total="12,489"
    icon="features/scan.svg"></app-statistics-card>
</div>